import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceGlobals = /*#__PURE__*/function (_Service) {
  _inherits(ServiceGlobals, _Service);

  var _super = _createSuper(ServiceGlobals);

  function ServiceGlobals() {
    _classCallCheck(this, ServiceGlobals);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceGlobals, [{
    key: "fetchVariableOptions",
    value: function fetchVariableOptions(variableName) {
      var params;
      if (Array.isArray(variableName)) params = {
        variable_names: variableName
      };else params = {
        variable_name: variableName
      };
      return this.axiosInstance.get(ENDPOINTS.globals.variables, {
        params: params
      });
    }
  }, {
    key: "fetchStatusOptions",
    value: function fetchStatusOptions(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          prefix = _ref.prefix;
      return this.axiosInstance.get(ENDPOINTS.globals.status, {
        params: {
          limit: limit,
          offset: offset,
          prefix: prefix
        }
      });
    }
  }, {
    key: "fetchRestworldRating",
    value: function fetchRestworldRating() {
      return this.axiosInstance.get(ENDPOINTS.globals.restworldRating);
    }
  }, {
    key: "compressImage",
    value: function compressImage(image, sizeThreshold) {
      var formData = new FormData();
      formData.append('image', image);
      formData.append('size_threshold', sizeThreshold.toString());
      return this.axiosInstance.post(ENDPOINTS.globals.compressImage, formData, {
        responseType: 'arraybuffer'
      });
    }
  }, {
    key: "createShortenUrl",
    value: function createShortenUrl(_ref2) {
      var original_url = _ref2.original_url;
      return this.axiosInstance.post(ENDPOINTS.globals.shortenUrl, {
        original_url: original_url
      });
    }
  }, {
    key: "getShortenUrls",
    value: function getShortenUrls(_ref3) {
      var limit = _ref3.limit,
          last_evaluated_key = _ref3.last_evaluated_key;
      return this.axiosInstance.get(ENDPOINTS.globals.shortenUrl, {
        params: {
          limit: limit,
          last_evaluated_key: last_evaluated_key
        }
      });
    }
  }, {
    key: "deleteShortenUrl",
    value: function deleteShortenUrl(shortedUrlId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.globals.shortenUrl), {
        data: {
          id: shortedUrlId
        }
      });
    }
  }]);

  return ServiceGlobals;
}(Service);

export var globalServices = function globalServices(_ref4) {
  var baseUrl = _ref4.baseUrl,
      jwt = _ref4.jwt;
  return new ServiceGlobals(dynamicAxios(baseUrl, jwt));
};
export function useGlobalsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceGlobals(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useGlobalsService;
export * from './types';